const enrolmentWorkflowsByCourse = (
  state = {
    isFetching: false,
    receivedAt: null,
    data: [],
  },
  action
) => {
  switch (action.type) {
    case 'REQUEST_ENROLMENT_WORKFLOWS':
      return {
        ...state,
        isFetching: true,
      }
    case 'RECEIVE_ENROLMENT_WORKFLOWS':
      return {
        ...state,
        isFetching: false,
        receivedAt: Date.now(),
        data: action.enrolmentWorkflows,
      }
    default:
      return state
  }
}

const enrolmentWorkflows = (state = {}, action) => {
  switch (action.type) {
    case 'RECEIVE_COURSES':
      return {
        ...state,
        ...action.courses.reduce((accumulator, currentCourse) => {
          return {
            ...accumulator,
            [currentCourse.courseId]: enrolmentWorkflowsByCourse(state[currentCourse.courseId], action),
          }
        }, {})
      }
    case 'REQUEST_ENROLMENT_WORKFLOWS':
    case 'RECEIVE_ENROLMENT_WORKFLOWS':
      return {
        ...state,
        [action.courseId]: enrolmentWorkflowsByCourse(state[action.courseId], action)
      }
    default:
      return state
  }
}

export default enrolmentWorkflows
